module.exports = __webpack_public_path__ + "img/herrj.2943ee3c.jpg";